import { render, staticRenderFns } from "./GeneralCard.vue?vue&type=template&id=7781372a&scoped=true&"
import script from "./GeneralCard.vue?vue&type=script&lang=ts&"
export * from "./GeneralCard.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralCard.vue?vue&type=style&index=0&id=7781372a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7781372a",
  null
  
)

export default component.exports